import apiClient from '@/services/axios'
import { transformIntoQuery } from '@/utils/pagination'

class ReportService {
  constructor() {
    this.$api = apiClient
  }

  getLog(pagination, sorting, filter) {
    const query = transformIntoQuery(pagination, sorting, filter)
    return this.$api.get(`/admin/log-event${query}`)
  }

  getCategories() {
    return this.$api.get('/admin/log-event/categories')
  }

  getCodes() {
    return this.$api.get('/admin/log-event/codes')
  }
}

export default new ReportService()
